import {
    ShipmentsData,
    ShipmentsDetailsData,
    ShipmentsHeadCellContent,
} from 'models/Shipments';
import { HeadCell } from '../../../models/TableProps';
import { BasicHeadCell } from 'models/BasicTable/BasicTableProps';

export const SHIPMENTS_HEAD_CELLS: HeadCell<ShipmentsHeadCellContent>[] = [
    {
        id: 'number',
        numeric: false,
        disablePadding: false,
        label: 'SHIPMENT_NUMBER',
        sortable: true,
    },
    {
        id: 'customerName',
        numeric: true,
        disablePadding: false,
        label: 'CUSTOMER',
        sortable: true,
    },
    {
        id: 'invoiceDate',
        numeric: true,
        disablePadding: false,
        label: 'DATE',
        sortable: true,
    },
    {
        id: 'orderNumber',
        numeric: true,
        disablePadding: false,
        label: 'SHOPIFY_ORDER_ID',
        sortable: true,
    },
];

export const SHIPMENT_LABEL_DETAILS_HEAD_CELLS: BasicHeadCell<ShipmentsData>[] =
    [
        {
            id: 'number',
            disablePadding: false,
            label: 'SHIPMENT_NUMBER',
        },
        {
            id: 'customerName',
            disablePadding: false,
            label: 'CUSTOMER',
        },
        {
            id: 'invoiceDate',
            disablePadding: false,
            label: 'DATE',
        },
        {
            id: 'orderNumber',
            disablePadding: false,
            label: 'SHOPIFY_ORDER_ID',
        },
    ];

export const SHIPMENT_LABEL_PRODUCTS_HEAD_CELLS: HeadCell<ShipmentsDetailsData>[] =
    [
        {
            id: 'lineObjectNumber',
            disablePadding: false,
            label: 'SKU',
            numeric: false,
            sortable: true,
        },
        {
            id: 'description',
            disablePadding: false,
            label: 'TITLE',
            numeric: false,
            sortable: true,
        },
        {
            id: 'quantity',
            disablePadding: false,
            label: 'QUANTITY',
            numeric: false,
            sortable: true,
        },
        {
            id: 'unitPrice',
            disablePadding: false,
            label: 'UNIT_PRICE',
            numeric: false,
            sortable: true,
        },
        {
            id: 'taxPercent',
            disablePadding: false,
            label: 'TAX',
            numeric: false,
            sortable: true,
        },
        {
            id: 'discountPercent',
            disablePadding: false,
            label: 'DISCOUNT',
            numeric: false,
            sortable: true,
        },
        {
            id: 'shipmentDate',
            disablePadding: false,
            label: 'SHIPMENT_DATE',
            numeric: false,
            sortable: true,
        },
    ];
